import { AdminApiError } from './api'

const TECHNICAL_PATTERNS = [
  'internal',
  'exception',
  'traceback',
  'invalid request',
  'stack',
  'mt5manager',
  'pip install',
  '\\downloads\\',
  '/downloads/',
  '.whl',
  'package is not installed',
  'metaquotes',
  'account creation disabled',
  'mt5_allow',
  'feature flag',
  'failed to fetch',
  'networkerror',
  'bearer',
  'authorization',
  'secret',
  'password hash',
  'api key',
  'traceback',
]

function looksTechnical(message: string): boolean {
  const lower = message.toLowerCase().trim()
  if (!lower) return true
  if (lower === 'invalid request') return true
  // Keep normal login/auth copy visible.
  if (
    lower.includes('credential') ||
    lower.includes('sign in') ||
    lower.includes('email or password') ||
    lower.includes('session expired')
  ) {
    return false
  }
  return TECHNICAL_PATTERNS.some((p) => lower.includes(p))
}

/** Strip technical/internal error text before showing admins. */
export function safeAdminError(err: unknown, fallback: string): string {
  if (err instanceof AdminApiError) {
    const msg = (err.message || '').trim()
    if (!msg || looksTechnical(msg)) return fallback
    return msg
  }
  if (err instanceof Error && err.message) {
    const msg = err.message.trim()
    if (!msg || looksTechnical(msg)) return fallback
    return msg
  }
  return fallback
}

/** Alias matching shared naming used across admin pages. */
export function safeError(err: unknown, fallback: string): string {
  return safeAdminError(err, fallback)
}

export function maskLogin(login: number | string | null | undefined): string {
  const text = String(login ?? '').trim()
  if (!text) return '—'
  if (text.includes('*')) return text
  if (text.length <= 2) return `**${text}`
  return `***${text.slice(-2)}`
}

export function moneySigned(
  value: number | string | null | undefined,
  currency = 'USD',
): string {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  if (Number.isNaN(n)) return '—'
  const sign = n > 0 ? '+' : ''
  return `${sign}${n.toFixed(2)} ${currency}`
}

export function formatWhen(value?: string | null): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return value
  return d.toLocaleString()
}

export function formatDateOnly(value?: string | null): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return value
  return d.toLocaleDateString()
}

export function eventTimestamp(ev: Record<string, unknown>): string {
  return String(ev.timestamp || ev.created_at || ev.time || '')
}

export function eventDescription(ev: Record<string, unknown>): string {
  return String(ev.description || ev.message || ev.summary || '')
}
